angular.module('menu').controller('HelpMenuController', [
    'AccountManager',
    'Event',
    function(AccountManager, Event) {
        var vm = this;

        vm.$onInit = function() {
            vm.guidesLinks = {
                en: 'https://help.sharecrf.com/portal-user-guide',
            };

            return AccountManager.init()
                .then(function() {
                    reloadUserData(vm);
                });
        };

        vm.toggle = function() {
            vm.visible = !vm.visible;
        };

        Event.on('login', function() {
            reloadUserData(vm);
        });
        Event.on('logout', function() {
            reloadUserData(vm);
        });

        function reloadUserData(ctrl) {
            ctrl.loggedUser = AccountManager.getLoggedUser();
            ctrl.initied = true;
        }
    },
]);
